import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { QuestionPayloadType } from "@/common/types/question";

export async function methodQuestionList(
  account_id: string,
  group_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/method/${group_id}/question/list${queryString}`,
  );
}

export async function methodQuestionShow(
  account_id: string,
  question_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/method/question/${question_id}/show`,
  );
}

export async function methodQuestionCreate(
  account_id: string,
  group_id: string,
  payload: QuestionPayloadType,
) {
  const formated = {
    ...payload,
    metadata:
      typeof payload.metadata === "object"
        ? JSON.stringify(payload.metadata)
        : payload.metadata,
  };

  return await clientAxios.post(
    `account/${account_id}/method/${group_id}/question/create`,
    formated,
  );
}

export async function methodQuestionUpdate(
  account_id: string,
  question_id: string,
  payload: QuestionPayloadType,
) {
  const formated = {
    ...payload,
    metadata: JSON.stringify(payload.metadata).toString(),
  };

  return await clientAxios.put(
    `account/${account_id}/method/question/${question_id}/update`,
    formated,
  );
}

export async function methodQuestionPatch(
  account_id: string,
  question_id: string,
  payload: Partial<QuestionPayloadType>,
) {
  const formated = {
    ...payload,
    metadata: JSON.stringify(payload.metadata).toString(),
  };

  return await clientAxios.patch(
    `account/${account_id}/method/question/${question_id}/patch`,
    formated,
  );
}

export async function methodQuestionDelete(
  account_id: string,
  question_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/method/question/${question_id}/delete`,
  );
}
